import { calculationService } from './calculator';
import { REQUEST_LOAN_RESULTS } from '../../../actions/namPersonalLoansCalculator/calculator';

export const namPersonalLoansCalculatorService = (store, next, action) => {
    if (action.type === REQUEST_LOAN_RESULTS) {
        return calculationService(store, next, action);
    }

    return null;
};
